import React from 'react';

/**
 * What has already happened to this deliverable: changes logged against the
 * current version, and the versions that came before.
 *
 * Extracted from EpisodeReview 18 Sep 2026. Both lists are read-only — a
 * client can add a change but never edit or withdraw one, because Portal may
 * already have acted on it by the time they change their mind.
 */

interface ChangeRequestRow {
  id: string;
  timecode?: string;
  authorName: string;
  resolved?: boolean;
  body: string;
  time: string;
}
interface VersionRow {
  id: string;
  version: string;
  label: string;
  date: string;
  changeCount?: number;
  visibleToClient: boolean;
}
interface ReviewHistoryProps {
  version: string;
  currentChanges: ChangeRequestRow[];
  versions: VersionRow[];
  onWatch: (version: string) => void;
}
export function ReviewHistory({
  version,
  currentChanges,
  versions,
  onWatch
}: ReviewHistoryProps) {
  const visibleVersions = versions.filter(entry => entry.visibleToClient);
  return <>
      {currentChanges.length > 0 && <section aria-labelledby="requested-changes" className="mt-16" data-id="element-217" data-mp="929j5prdz8rp">
          <div className="flex flex-wrap items-baseline justify-between gap-4 border-b border-rule pb-4" data-id="element-218" data-mp="d3mq6367ti07">
            <h2 id="requested-changes" className="label m-0 text-graphite" data-id="element-219" data-mp="3v7wpap51r8jj">
              Requested Changes{version ? ` · ${version}` : ''}
            </h2>
            <p className="label-sm m-0 text-mute" data-id="element-220" data-mp="3lj6dymo4a87v">
              {currentChanges.length} change{currentChanges.length === 1 ? '' : 's'}
            </p>
          </div>
          <ul className="m-0 list-none p-0" data-id="element-221" data-mp="3qb68u0pbyaxl">
            {currentChanges.map(request => <li key={request.id} className="border-b border-rule py-6" data-id="element-222" data-mp="3ck1hrn012qyv">
                <div className="flex flex-wrap items-baseline gap-3" data-id="element-223" data-mp="3himidnj6zcnu">
                  <span className="label text-ink" data-id="element-224" data-mp="32kkdna0fcl50">
                    {request.timecode ? `${request.timecode} · ` : ''}
                    {request.authorName}
                  </span>
                  {/* Closes the gap between a request and the next version. */}
                  {request.resolved && <span className="label-sm text-graphite" data-id="element-225" data-mp="2jnikhg231pjr">✓ Completed by Portal</span>}
                </div>
                <p className="mt-2 max-w-2xl font-display text-xl leading-snug text-charcoal" data-id="element-226" data-mp="2epqni7mkzd8p">
                  {request.body}
                </p>
                <p className="label-sm mt-3 text-mute" data-id="element-227" data-mp="37dmnbl7g5l9p">Sent {request.time}</p>
              </li>)}
          </ul>
        </section>}

      {visibleVersions.length > 0 && <section aria-labelledby="previous-versions" className="mt-16" data-id="element-228" data-mp="32cp02u7ky11c">
          <h2 id="previous-versions" className="label border-b border-rule pb-4 text-graphite" data-id="element-229" data-mp="2xdly5imwcaxl">
            Previous Versions
          </h2>
          <ul className="m-0 list-none p-0" data-id="element-230" data-mp="1m01pm3563tbb">
            {visibleVersions.map(entry => <li key={entry.id} className="flex flex-wrap items-baseline justify-between gap-4 border-b border-rule py-5" data-id="element-231" data-mp="1h1gm9uumctin">
                <span className="flex items-baseline gap-5" data-id="element-232" data-mp="3smh5xx3yaktl">
                  <span className="font-display text-2xl leading-none" data-id="element-233" data-mp="1jaljxtle89t">{entry.version}</span>
                  <span className="label-sm text-mute" data-id="element-234" data-mp="6gassc26hh2i">
                    {entry.label} · {entry.date}
                    {entry.changeCount ? ` · ${entry.changeCount} change${entry.changeCount === 1 ? '' : 's'}` : ''}
                  </span>
                </span>
                <button type="button" onClick={() => onWatch(entry.version)} className="label text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-235" data-mp="k7fj2njnox06">
                  Watch
                </button>
              </li>)}
          </ul>
        </section>}
    </>;
}